module.exports = __webpack_public_path__ + "img/44.7aec5542.png";